import React from 'react'

const SvgBugFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.915 10.909A1.596 1.596 0 004.43 12H7a1 1 0 100-2H4.72l-.772-2.316a1 1 0 10-1.897.633l.864 2.592zM21.084 10.909A1.596 1.596 0 0119.57 12H17a1 1 0 110-2h2.279l.772-2.316a1 1 0 111.897.633l-.864 2.592zM2.915 18.092A1.596 1.596 0 014.43 17H7a1 1 0 110 2H4.72l-.772 2.316a1 1 0 11-1.897-.632l.864-2.592zM2 14.5a1 1 0 001 1h4a1 1 0 100-2H3a1 1 0 00-1 1zM16 14.5a1 1 0 001 1h4a1 1 0 000-2h-4a1 1 0 00-1 1zM15.552 6.28a1 1 0 01-.447-1.341l1.193-2.386a1 1 0 111.79.894l-1.194 2.386a1 1 0 01-1.342.448zM8.64 6.28a1 1 0 01-1.342-.447L6.105 3.447a1 1 0 111.79-.894l1.192 2.386a1 1 0 01-.447 1.342zM21.084 18.092A1.596 1.596 0 0019.57 17H17a1 1 0 100 2h2.279l.772 2.316a1 1 0 101.897-.632l-.864-2.592z'
    />
    <path d='M11 21.955V15a1 1 0 112 0v6.955c4-.492 6-3.992 6-8.853 0-.872-.077-1.963-.29-3.102H5.29C5.077 11.14 5 12.23 5 13.102c0 4.86 2 8.36 6 8.853zM18.189 8H5.81C6.716 5.367 8.534 3 12 3c3.465 0 5.284 2.367 6.189 5z' />
  </svg>
)

export default SvgBugFilled
